import React, { useContext, useEffect, useState } from 'react';
import { appContext } from "./../../AppContext";
import { Tabs } from 'antd';
import {useFetch} from './../../utils/hooks/useFetch'
import PlayerCharacters from './player/PlayerCharacters';
import PlayerCharactersAdmin from './admin/PlayerCharactersAdmin';

const { TabPane } = Tabs;

export default function StormvloedCharacterBuilder() {

    const [doFetch] = useFetch();
    const [appState, AppDispatch] = useContext(appContext);

    const [characterTypes, setCharacterTypes] = useState([]);
    const [characterStatusses, setCharacterStatusses] = useState([]);
    const [races, setRaces] = useState([]);

     useEffect(() => {
        doFetch("/api/skillPoint/GetAll")
            .then((response) => skillPointTypesLoaded(response.isSuccess, response.result))

        function skillPointTypesLoaded(isSuccess, result) {
          if(isSuccess) {
            AppDispatch({ type: "SETSKILLPOINTTYPES", payload: result })
          }
        }

        doFetch("/api/skillPoint/GetAllStatTypes")
            .then((response) => statTypesLoaded(response.isSuccess, response.result))

        function statTypesLoaded(isSuccess, result) {
          if(isSuccess) {
            AppDispatch({ type: "SETSTATTYPES", payload: result })
          }
        }

        doFetch("/api/character/GetCharacterTypes")
            .then((response) => characterTypesLoaded(response.isSuccess, response.result))

        function characterTypesLoaded(isSuccess, result) {
          if(isSuccess) {
            setCharacterTypes(result)
          }
        }

        doFetch("/api/character/GetCharacterStatusses")
            .then((response) => characterStatussesLoaded(response.isSuccess, response.result))

        function characterStatussesLoaded(isSuccess, result) {
          if(isSuccess) {
            setCharacterStatusses(result)
          }
        }

        doFetch(`/api/race/${appState.storyId}/GetWiki`)
            .then((response) => racesLoaded(response.isSuccess, response.result))

        function racesLoaded(isSuccess, result) {
            if(isSuccess) {
                setRaces(result)
            }
        }
    },     //eslint-disable-next-line
    [appState.storyId])

    return (
      <>
        <Tabs defaultActiveKey="1">
            {appState.isSlOfStory && <TabPane tab="SL" key="1">
                <PlayerCharactersAdmin 
                    characterStatusses={characterStatusses}
                    characterTypes={characterTypes}
                    races={races}
                />
            </TabPane>}
            {/* {appState.isSlOfStory && <TabPane tab="Admin" key="2">
                <CharacterAdmin />
            </TabPane>} */}
            <TabPane tab="My character" key="3">
                <PlayerCharacters 
                    characterStatusses={characterStatusses}
                    characterTypes={characterTypes}
                    races={races}
                />
            </TabPane>
            {/* <TabPane tab="Wiki" key="4">
                <Tabs defaultActiveKey="5">
                    <TabPane tab="Skills" key="5">
                        <SkillWiki />
                    </TabPane>
                    <TabPane tab={isStormvloed ? "Race" : "World"} key="6">
                        <RaceWiki />
                    </TabPane>
                    {isAgnoia && appState.isSlOfStory &&
                    <TabPane tab="Items" key="7">
                        <AgnoiaItemWiki />
                    </TabPane>}
                    {isAgnoia &&
                    <TabPane tab="Alchemy" key="8">
                        <AgnoiaAlchemyWiki />
                    </TabPane>}
                    
                    <TabPane tab="Links" key="9">
                        <>
                            {isStormvloed &&
                            <>
                            <a target='_blank' rel="noopener noreferrer" href={links.rules}>
                                Rules
                            </a>
                            <br />
                            </>}
                            <a target='_blank' rel="noopener noreferrer" href={links.larptomRules}>
                                Algemene regels
                            </a>
                            <br />
                            {isStormvloed && <a target='_blank' rel="noopener noreferrer" href={links.otherDocuments}>
                                Andere documenten
                            </a>}
                        </>
                    </TabPane>
                </Tabs>
            </TabPane> */}
        </Tabs>
      </>
    )
}


